/**
 * Simple module-level store for current workspace.
 * Updated by WorkspaceContext, read by API client and PaymentContext.
 *
 * This enables automatic workspace injection into API calls
 * without requiring hooks to pass workspaceId explicitly.
 */

type Listener = (id: string | null) => void;

let currentWorkspaceId: string | null = null;
const listeners = new Set<Listener>();

export function setCurrentWorkspaceId(id: string | null): void {
  currentWorkspaceId = id;
  listeners.forEach((fn) => fn(id));
}

export function getCurrentWorkspaceId(): string | null {
  return currentWorkspaceId;
}

/** The current workspace, for a call whose route names it; throws when none is selected. */
export function requireCurrentWorkspaceId(): string {
  if (!currentWorkspaceId) throw new Error("No workspace specified");
  return currentWorkspaceId;
}

/**
 * Subscribe to workspace ID changes.
 * Returns an unsubscribe function.
 */
export function subscribeToWorkspaceId(listener: Listener): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
